<template>
  <el-image
    :src="`${realSrc}`"
    fit="cover"
    :style="`width:${readlWidth};height:${realHeight};`"
    :preview-src-list="realSrcList"
  >
    <template #error>
      <div class="image-slot">
        <span>暂无</span>
      </div>
    </template>
  </el-image>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    src: {
      type: String,
      default: ''
    },
    width: {
      type: Number || String,
      default: ''
    },
    height: {
      type: Number || String,
      default: ''
    }
  },
  computed: {
    realSrc() {
      if (!this.src) {
        return;
      }
      let real_src = this.src;
      return real_src;
    },
    realSrcList() {
      if (!this.src) {
        return [];
      }
      let real_src_list = this.src.split(',');
      let srcList = [];
      real_src_list.forEach((item) => {
        if (item.trim() === '') {
          return;
        }

        return srcList.push(item);
      });
      console.log(srcList);
      return srcList;
    },
    readlWidth() {
      return typeof this.width == 'string' ? this.width : `${this.width}px`;
    },
    realHeight() {
      return typeof this.height == 'string' ? this.height : `${this.height}px`;
    }
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.el-image {
  border-radius: 5px;
  background-color: #ebeef5;
  box-shadow: 0 0 5px 1px #ccc;

  :deep(.el-image__inner) {
    transition: all 0.3s;
    cursor: pointer;

    &:hover {
      transform: scale(1.2);
    }
  }

  :deep(.image-slot) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    color: #909399;
    font-size: 30px;
  }
}
</style>
